import { GuestSiteComponentProps } from '@apps/websiteCustomJsonComponents/types';
import { Box, Flex, SpacingStack, TextV2 } from '@withjoy/joykit';
import React from 'react';
import { FaqData } from '../Faq.types';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { body4ToParagraphOverride, hed2ToSubHeadingOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';
import { pxToRem } from '@withjoy/joykit/theme';
import { PrettyLink } from '@apps/guest/packages/layout-engine/components/PrettyLink';

export const FaqGuest = (props: GuestSiteComponentProps) => {
  const data = props.data.content as FaqData;

  if (!data?.items || data.items.length === 0) {
    return null;
  }

  return (
    <Box width="100%">
      <SpacingStack
        flexDirection="column"
        spacing={9}
      >
        {data.items.map((item, index) => (
          <Flex
            key={index}
            flexDirection="column"
          >
            <GuestSiteTypographyOverride override={hed2ToSubHeadingOverride}>
              <TextV2
                wordBreak="break-word"
                typographyVariant="hed2"
              >
                {item.title}
              </TextV2>
            </GuestSiteTypographyOverride>
            <GuestSiteTypographyOverride override={body4ToParagraphOverride}>
              <TextV2
                wordBreak="break-word"
                typographyVariant="body4"
                marginTop={pxToRem(10)}
                tagName="div"
              >
                <PrettyLink>{item.subtitle}</PrettyLink>
              </TextV2>
            </GuestSiteTypographyOverride>
          </Flex>
        ))}
      </SpacingStack>
    </Box>
  );
};
